import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BuiltForTheLongHaul() {
  return <section data-section-id="6605" id="keeping-your-line-moving" className="dark relative h-screen min-h-[600px] w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-blue-950/40 via-background/70 to-background" />

      {}
      <div className="relative z-20 flex h-full flex-col items-center justify-center px-4 text-center sm:px-8">
        <div className="max-w-5xl space-y-8">
          {}
          <h1 className="font-sans text-5xl font-black uppercase tracking-tighter text-white sm:text-6xl md:text-7xl lg:text-8xl drop-shadow-2xl">
            KEEPING YOUR LINE MOVING
          </h1>

          {}
          <p className="font-sans text-lg font-medium text-muted-foreground sm:text-xl md:text-2xl drop-shadow-md">
            Authorized Expertise in Miller, Lincoln, and Hypertherm Repairs.
          </p>

          {}
          <div className="flex flex-col items-center justify-center gap-4 pt-8 sm:flex-row sm:gap-6">
            <Button asChild size="lg" className="h-14 min-w-[200px] rounded-md bg-primary text-lg font-bold text-primary-foreground shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:bg-primary/90 hover:shadow-[0_0_30px_rgba(245,158,11,0.5)]">
              <Link to="/RequestServicePage">Book Service</Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="h-14 min-w-[200px] rounded-md border-2 border-primary bg-transparent text-lg font-bold text-white hover:bg-primary hover:text-primary-foreground hover:border-primary">
              <Link to="/RepairSolutionsPage">View Capabilities</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 z-20 -translate-x-1/2 animate-bounce">
        <Link to="#repair-solutions" aria-label="Scroll down">
          <ChevronDown className="h-10 w-10 text-primary/70 hover:text-primary transition-colors" />
        </Link>
      </div>
    </section>;
}